import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'assignments',
  templateUrl: './assignments.component.html',
  styleUrls: ['./assignments.component.scss'],
})
export class AssignmentsComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

}
